import HTMLReactParser, { Element, Text } from 'html-react-parser';
import React from 'react';

export const parseMentions = (
  s: string,
  addInf?: (url: string, username: string) => void,
  GoToInf?: (data: any) => void,
  mentions?: Record<string, any>[],
) => {
  let newString = s?.replaceAll(/@[\w.]+/g, (word) => `<span>${word}</span>`);
  if (newString)
    return HTMLReactParser(newString, {
      replace: (domNode) => {
        if ((domNode as Element).name === 'span') {
          let innerText = (domNode as Element).children[0];
          let innerTextData = (innerText as Text).data;
          let currentMention = mentions?.find(
            (item) =>
              item.username?.toLowerCase() ===
              innerTextData.slice(1)?.toLowerCase(),
          );
          return (
            <span
              onClick={(e) => {
                e.stopPropagation();
                currentMention?.id === 0
                  ? addInf?.(
                      currentMention?.influencer?.url,
                      currentMention?.username,
                    )
                  : GoToInf?.(currentMention?.influencer);
              }}
            >
              {innerTextData}
            </span>
          );
        }
      },
    });

  return s;
};
